import { render, staticRenderFns } from "./FontsHeader.vue?vue&type=template&id=204ccbd4&scoped=true&"
import script from "./FontsHeader.vue?vue&type=script&lang=js&"
export * from "./FontsHeader.vue?vue&type=script&lang=js&"
import style0 from "./FontsHeader.vue?vue&type=style&index=0&id=204ccbd4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "204ccbd4",
  null
  
)

export default component.exports